"use client";

import { useLocale, useTranslations } from "next-intl";
import { usePathname, useRouter } from "@/i18n/navigation";
import { routing } from "@/i18n/routing";

export function LanguageSwitcher() {
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();
  const t = useTranslations("LanguageSwitcher");

  return (
    <div className="flex items-center gap-1">
      {routing.locales.map((loc) => (
        <button
          key={loc}
          onClick={() => {
            document.cookie = `NEXT_LOCALE=${loc}; path=/; SameSite=lax`;
            router.replace(pathname, { locale: loc });
          }}
          className={`font-mono text-[10px] px-1.5 py-0.5 rounded transition-colors ${
            locale === loc
              ? "bg-acid/20 text-acid"
              : "text-neutral-500 hover:text-neutral-300"
          }`}
        >
          {t(loc)}
        </button>
      ))}
    </div>
  );
}
